import axios from "axios";
const request = axios.create({
    baseURL: `/api`, // api base_url
    timeout: 60000 // 请求超时时间 单位 毫秒
})
request.interceptors.response.use((response) => {
    if (response.request.responseType === 'blob') {
        return response
    }
    const resData = response.data
    return resData
})

export {
    request as axios
}
